import React from 'react';
import { useSelector } from 'react-redux';

import { TState } from '~/src/store';

export interface ISeoScriptAggregateRating {
    name: string,
    ratingValue: string,
    ratingCount: string,
}

const SeoScriptAggregateRating = ({ name, ratingValue, ratingCount }: ISeoScriptAggregateRating) => {
    const logo = useSelector((state: TState) => state.city.currentCity.logoFull);

    return <script
        id={'rating'}
        type={'application/ld+json'}
        dangerouslySetInnerHTML={{
            __html: JSON.stringify({
                '@context': 'https://schema.org/',
                '@type': 'Product',
                'name': name,
                'image': logo,

                'aggregateRating': {
                    '@type': 'AggregateRating',
                    'ratingValue': ratingValue,
                    'bestRating': '5',
                    'worstRating': '',
                    'ratingCount': ratingCount,
                },
            }),
        }}
    />;
};

export default SeoScriptAggregateRating;
